import { Account } from "@services/account/types";

export const hasAccountReachedRoomLimit = (account: Account | undefined) => {
  const limit =
    account?.accountEntitlementOptions?.options?.roomMonitoring?.quantity;
  const used = account?.summary?.totalRooms ?? 0;

  // If the limit is undefined, which shouldn't happen, don't assume anything
  if (limit === undefined) return false;
  return limit <= used;
};
